import { getCloudinaryUrl } from "@core-ui/helpers/Image";

import React, { memo, ReactElement } from "react";

import styles from "../../../BillDetailItem.scss";

export const META_ICON_WIDTH = 16;

const Icon = ({ icon }: { icon?: string }): ReactElement | null => {
    if (!icon) return null;

    return (
        <div className={styles.displayValueIcon}>
            <img crossOrigin="anonymous" src={getCloudinaryUrl(icon)} width={META_ICON_WIDTH} alt="Show Value" />
        </div>
    );
};

export default memo(Icon);
